import type { RQueue } from 'v2/types/api/settings'

const QUEUE_STORAGE_KEY = 'queueToOpen'

export const setQueueToOpen = (queue: RQueue | boolean | null) => {
  if (queue !== null) {
    localStorage.setItem(QUEUE_STORAGE_KEY, JSON.stringify(queue))
  } else {
    localStorage.removeItem(QUEUE_STORAGE_KEY)
  }
}

export const getQueueToOpen = (): RQueue | boolean | null => {
  const storedQueue = localStorage.getItem(QUEUE_STORAGE_KEY)
  if (storedQueue) {
    return JSON.parse(storedQueue)
  }
  return null
}

export const clearQueueToOpen = () => {
  localStorage.removeItem(QUEUE_STORAGE_KEY)
}
